import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    BaseLeaseCategory, RangeType,
    RegionSecondLevel,
} from 'app/enums/label.enums'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    RateCardsTabs,
} from 'app/enums/domain.enums'

import requests from 'app/requests/RateCard/RateCard.requests'
import {
    MarginsTable,
} from './Margins.types'

const config: SkyNetTableTab<keyof MarginsTable> = {
    name: 'Margins',
    url: RateCardsTabs.Margins,
    customUrl: requests[RequestKeys.marginsFilterRequest]().url,
    fields: [
        {
            name: 'regionSecondLevel',
            labelKey: 'MarginsRateCard.regionSecondLevel',
            componentName: 'EnumValue',
            allowedValuesEnum: RegionSecondLevel,
        },
        {
            name: 'baseLeaseCategory',
            labelKey: 'MarginsRateCard.baseLeaseCategory',
            componentName: 'EnumValue',
            allowedValuesEnum: BaseLeaseCategory,
        },
        {
            name: 'logisticsDays',
            alignTextRight: true,
            labelKey: 'MarginsRateCard.logisticsDays',
        },
        {
            name: 'dropOffMargin',
            alignTextRight: true,
            labelKey: 'MarginsRateCard.dropOffMargin',
        },
        {
            name: 'positioningMargin',
            alignTextRight: true,
            labelKey: 'MarginsRateCard.positioningMargin',
        },
        {
            name: 'postponementFeeTimeline',
            alignTextRight: true,
            labelKey: 'MarginsRateCard.postponementFeeTimeline',
        },
        {
            name: 'postponementDaysType',
            labelKey: 'MarginsRateCard.postponementDaysType',
            componentName: 'EnumValue',
            allowedValuesEnum: RangeType,
        },
        {
            name: 'expressOrderTimeline',
            alignTextRight: true,
            labelKey: 'MarginsRateCard.expressOrderTimeline',
        },
        {
            name: 'expressDaysType',
            labelKey: 'MarginsRateCard.expressDaysType',
            componentName: 'EnumValue',
            allowedValuesEnum: RangeType,
        },
        {
            name: 'cancellationFeeTimeline',
            alignTextRight: true,
            labelKey: 'MarginsRateCard.cancellationFeeTimeline',
        },
        {
            name: 'cancellationDaysType',
            labelKey: 'MarginsRateCard.cancellationDaysType',
            componentName: 'EnumValue',
            allowedValuesEnum: RangeType,
        },
    ],
}

export default config
